module.exports = __webpack_public_path__ + "static/img/produto_g.b598633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina/produto_g.png
// module id = w3sr
// module chunks = 0